import Input from "../../utils/Input";
import App from "../../App";


class OurTeamDetailContact{
    constructor(){
        this.main = document.getElementById('our_team_detail_contact');

        this._titleName = this.main.querySelector('.title_name');

        this._inputName = new Input(this.main.querySelector('input[name="name"]'));
        this._inputEmail = new Input(this.main.querySelector('input[name="email"]'));
        //console.log("phone", this.main.querySelector('input[name="phone"]'))
        this._inputPhone = new Input(this.main.querySelector('input[name="phone"]'));
        this._inputPhone.numeric = true;

        this._inputMessage = new Input(this.main.querySelector('textarea[name="message"]'));

        this._sendBtn = this.main.querySelector('.send_btn');

        this._teamMemberId = null;

        this._sending = false;

        this._sendBtn.addEventListener('click', this._onClickSendBtn.bind(this));

    }

    _onClickSendBtn(e){
        e.preventDefault();
        
        if(!this._sending){
            let formOk = true;

            if(this._inputName.isEmpty){
                formOk = false;
                this._inputName.error = true;
            }else{
                this._inputName.error = false;
            }

            if(!this._inputEmail.isValidEmail){
                formOk = false;
                this._inputEmail.error = true;
            }else{
                this._inputEmail.error = false;
            }

            if(this._inputPhone.isEmpty || !this._inputPhone.isValidPhone){
                formOk = false;
                this._inputPhone.error = true;
            }else{
                this._inputPhone.error = false;
            }

            if(this._inputMessage.isEmpty){
                formOk = false;
                this._inputMessage.error = true;
            }else{
                this._inputMessage.error = false;
            }

            if(formOk){
                let requestData = {
                    name: this._inputName.value,
                    email: this._inputEmail.value,
                    phone: this._inputPhone.value,
                    message: this._inputMessage.value,
                    team_member_id: this._teamMemberId,
                    lang: App.lang,
                }

                this._sending = true;
                this._sendBtn.classList.add('btn--loading');

                fetch(App.baseUrl + 'our-team/contact', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Cache-Control': 'no-cache'
                    },
                    body: JSON.stringify(requestData)
                })
                .then((response) => {return response.json()})
                .then((data) => {
                    this._sending = false;
                    this._sendBtn.classList.remove('btn--loading');

                    if(!data.error){
                        App.alertMessage.show(this.main.getAttribute('data-msg-success'), true);
                        this._resetFields();
                    }else{
                        App.alertMessage.show(this.main.getAttribute('data-msg-error-server'));        
                    }
                });


            }else{
                App.alertMessage.show(this.main.getAttribute('data-msg-error-fields'));
            }
        }
    }

    set(data){
        this._titleName.innerHTML = data.first_name;
        this._teamMemberId = data.id;
        this._resetFields();
    }

    _resetFields(){
        this._inputName.reset();
        this._inputEmail.reset();
        this._inputPhone.reset();
        this._inputMessage.reset();
    }
}

export default OurTeamDetailContact;